window.Popper = require('@popperjs/core').default;

const bootstrap = require('bootstrap');
window.bootstrap = bootstrap;